import { render } from "./PressRelease.vue?vue&type=template&id=9b91faee&scoped=true"
import script from "./PressRelease.vue?vue&type=script&lang=js"
export * from "./PressRelease.vue?vue&type=script&lang=js"

import "./PressRelease.vue?vue&type=style&index=0&id=9b91faee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b91faee"]])

export default __exports__